import cn from "classnames";

//Material UI Components
import { TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from "@mui/lab";
import { Box, Divider, Typography } from "@mui/material";

// Components
import { CompoundPill } from "components/CompoundPill";

// Types
import { TWorkHistoryItemProps } from "../PersonWorkHistory.types";

// Styles
import { useStyles } from "./WorkHistoryItem.styles";

const WorkHistoryItem = ({
    highlightPosition,
    position,
    company,
    from,
    to,
    functions,
    hierarchy,
}: TWorkHistoryItemProps): JSX.Element => {
    const classes = useStyles();

    return (
        <TimelineItem
            className={cn(
                classes.missingOppositeContent,
                ...(highlightPosition.shouldHighlightPosition
                    ? [
                          {
                              [classes.highlighted]: highlightPosition?.hasCurrentPosition,
                              [classes.dimmed]: !highlightPosition?.hasCurrentPosition,
                          },
                      ]
                    : [])
            )}
        >
            <TimelineContent className={classes.timeLineContent}>
                <Box className={classes.positionContainer}>
                    <Typography variant="body1" fontWeight={700}>
                        {position}
                    </Typography>

                    {position && (
                        <Divider
                            className={classes.timeLineContentDivider}
                            sx={{
                                ...(!Boolean(company) && {
                                    display: "none",
                                }),
                            }}
                            orientation="vertical"
                            flexItem
                        />
                    )}

                    <Box
                        component="span"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            ...(!Boolean(company) && {
                                display: "none",
                            }),
                        }}
                    >
                        {company}
                    </Box>
                </Box>

                <Box textAlign="left">
                    <CompoundPill functions={functions} hierarchy={hierarchy} />
                </Box>

                <Box className={classes.timeLineContentDate}>
                    <Box component="span">
                        {from} - {to}
                    </Box>
                </Box>
            </TimelineContent>
            <TimelineSeparator>
                <TimelineDot variant="outlined" color="primary" classes={{ root: classes.dot }} />
                <TimelineConnector className={classes.connector} />
            </TimelineSeparator>
        </TimelineItem>
    );
};

export default WorkHistoryItem;
